export default "<p>project works!</p>\n";